export default {
    TYPES: [
        [385, 'Sales Office'],
        [386, 'Parts Store'],
    ],
}